import { z } from "@/zod";
import { dictionary } from "@/schemas/dictionary";
import { projectId } from "@/schemas/commonFields";

const projectRole = dictionary.extend({
  name: z.string().trim().min(1),
  description: z.string().optional(),
  project_id: projectId,
});

export const readProjectRole = projectRole.readonly();
export const writeProjectRole = projectRole.omit({
  id: true,
  project_id: true,
});
